var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import * as React from 'react';
import { Callout, mergeStyleSets, Text, IconButton, Stack, Icon } from '@fluentui/react';
import { useState } from 'react';
import { useAppSelector } from '../../store/app.store';
import { assignmentDetailsSelectorById } from '../../store/Slices/AssignmentDetailsSlice';
import { selectGridCellByRowId } from '../../store/Slices/GridCellSlice';
import moment from 'moment';
export const CallOutComponent = ({ rowIdentifier, }) => {
    var _a, _b, _c;
    const methodName = 'CallOutComponent';
    const [isCalloutVisible, setIsCalloutVisible] = useState(false);
    const [infoIconId] = useState('info-icon' + rowIdentifier.toString());
    const [labelId] = useState('callout-label');
    const [descriptionId] = useState('callout-description');
    const stackTokens = { childrenGap: 10 };
    const data = (_a = useAppSelector(assignmentDetailsSelectorById(rowIdentifier))) === null || _a === void 0 ? void 0 : _a.customProperties;
    const gridCells = useAppSelector(selectGridCellByRowId(rowIdentifier.toString()));
    const updatedCellsSum = gridCells.reduce((sum, cell) => { return sum + cell.currValue; }, 0);
    const updatedCellsPreviousSum = gridCells.reduce((sum, cell) => { return sum + cell.prevValue; }, 0);
    const requestedDurationInHours = (_b = data === null || data === void 0 ? void 0 : data.RequestedDurationInHours) !== null && _b !== void 0 ? _b : 0; // maps to TotalRequestedHours
    const laborApprovedHours = (_c = data === null || data === void 0 ? void 0 : data.laborApprovedHours) !== null && _c !== void 0 ? _c : 0; // maps to LaborApprovedHours
    const totalForecastHours = (data === null || data === void 0 ? void 0 : data.totalForecastHours) + updatedCellsSum - updatedCellsPreviousSum; // maps to TotalForecastHours
    const remainingHours = requestedDurationInHours - laborApprovedHours - totalForecastHours;
    const remainingDays = (data === null || data === void 0 ? void 0 : data.RequestedEndDate) ? moment(data.RequestedEndDate).diff(moment(), 'days') : 0;
    const toggleIsCalloutVisible = () => {
        //const telemetryService = new TelemetryService();
        //(telemetryService).logEvent(EventCodes.EvE360, methodName, EventCodes.Ev0088, null, telemetryService.getCorrelationId());
        setIsCalloutVisible(!isCalloutVisible);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { iconProps: { iconName: 'Info' }, id: infoIconId, onClick: toggleIsCalloutVisible, className: styles.infoIcon, ariaLabel: 'Click to see the forecast hour breakup' }),
        isCalloutVisible && (React.createElement(Callout, { className: styles.callout, ariaLabelledBy: labelId, ariaDescribedBy: descriptionId, role: "alert", gapSpace: 0, target: `#${infoIconId}`, onDismiss: toggleIsCalloutVisible, setInitialFocus: true },
            React.createElement(Stack, { tokens: stackTokens, style: { paddingRight: 16 } },
                React.createElement(Text, { className: styles.title }, "Forecast hour breakup"),
                React.createElement(Stack, { horizontal: true, style: { justifyContent: 'space-between', alignItems: 'center' } },
                    React.createElement(Stack, { horizontal: true },
                        React.createElement(Icon, { iconName: 'SquareShapeSolid', style: { color: '#637CEF' } }),
                        React.createElement(Text, { style: { fontSize: 12, marginLeft: '5px' } }, " Actual Hours (till last week)")),
                    React.createElement(Text, { style: { fontWeight: 600, fontSize: 12 } },
                        "  ",
                        laborApprovedHours,
                        " Hrs")),
                React.createElement(Stack, { horizontal: true, style: { justifyContent: 'space-between', alignItems: 'center' } },
                    React.createElement(Stack, { horizontal: true },
                        React.createElement(Icon, { iconName: 'SquareShapeSolid', style: { color: '#218721' } }),
                        React.createElement(Text, { style: { fontSize: 12, marginLeft: '5px' } }, " Forecasted Hours")),
                    React.createElement(Text, { style: { fontWeight: 600, fontSize: 12 } },
                        "  ",
                        totalForecastHours,
                        " Hrs")),
                React.createElement(Stack, { horizontal: true, style: { justifyContent: 'space-between', alignItems: 'center' } },
                    React.createElement(Stack, { horizontal: true },
                        React.createElement(Icon, { iconName: 'SquareShapeSolid', style: { color: '#EDEBE9' } }),
                        React.createElement(Text, { style: { fontSize: 12, marginLeft: '5px' } }, " Remaining Hours")),
                    React.createElement(Text, { style: { fontWeight: 600, fontSize: 12 } },
                        " ",
                        remainingHours,
                        " Hrs")),
                React.createElement(Text, null,
                    " Ends after ",
                    remainingDays,
                    " days"))))));
};
const styles = mergeStyleSets({
    infoIcon: {
        fontSize: '10px',
        color: '#242424',
        cursor: 'pointer',
        alignSelf: 'center',
    },
    callout: {
        width: 300,
        height: 170,
        maxWidth: '90%',
        padding: '12px 16px 16px 16px',
    },
    title: {
        marginBottom: 12,
        fontWeight: 600,
        fontSize: '20px',
        size: '20px',
        LineHeight: '20px',
        height: '20px',
    },
    link: {
        display: 'block',
        marginTop: 20,
    },
});
export default CallOutComponent;
//# sourceMappingURL=CallOutComponent.js.map